import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal, selectStandard } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { dataSorting, findKeyBaseOnValue, formatTypeAheadOptions } from '../../ModificationsUtils';

interface PaymentTypeProps {
  readOnly?: boolean;
}

export const PaymentType = ({ readOnly }: PaymentTypeProps) => {
  const { control, getValues, setValue, register, clearErrors, setError } = useFormContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);
  const paymentType = 'paymentType';
  register('paymentTypeId');
  const isModEdit = useSelector(selectIsEditMod);
  const standard = useSelector(selectStandard);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const [bonusPaymentTypeOptions, setBonusPaymentTypeOptions] = useState([]);

  const getBonusPaymentTypeDropDown = async () => {
    const options = await getSearchFilterOptions('paymentType');

    if (options?.length > 0) {
      const newOptions = formatTypeAheadOptions(options);
      setBonusPaymentTypeOptions(newOptions);

      if (getValues(paymentType)) {
        const selectedOption = findKeyBaseOnValue(newOptions, getValues(paymentType));

        setValue('paymentTypeId', selectedOption?.id);
        clearErrors(paymentType);
      } else {
        setError(paymentType, {});
      }
      if (isUndoModal) {
        dispatch(placementModsAction.setIsUndoModal(false));
      }
    }
  };

  const getPaymentTypeId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(bonusPaymentTypeOptions, value);
    return selectedOption?.id;
  };

  const handleChange = (value?: string) => {
    setValue(paymentType, value);
    setValue('paymentTypeId', getPaymentTypeId(value));
    if (value) {
      clearErrors(paymentType);
    }
  };

  useEffect(() => {
    getBonusPaymentTypeDropDown();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <Controller
      control={control}
      name={paymentType}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          name={paymentType}
          label={`${t('placement.placementMods.paymentType')} *`}
          standard={true}
          options={dataSorting(bonusPaymentTypeOptions) ?? []}
          handleChange={e => {
            handleChange(e.target.value);
            onChange(e.target.value);
          }}
          {...rest}
          inputValue={getValues(paymentType) ?? ''}
          readOnly={readOnly !== undefined ? readOnly : (standard ? standard : !isModEdit)}
          disabled={isSaveModApiCalling}
        ></FormInputDropdown>
      )}
    />
  );
};
